import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Taxiserviceinpimprichichwadpune() {



  const cardData =
  {
    keyword: 'Taxi Service in Pimpri Chinchwad Pune',
    heading: 'Sanavi Travels: Taxi Service in Pimpri Chinchwad Pune',
    headingDescription: 'Sanavi Travels offers reliable Taxi Service in Pimpri Chinchwad Pune, providing safe, comfortable, and hassle-free transportation for local travel, outstation trips, airport transfers, corporate travel, and special occasions. Our fleet of well-maintained hatchbacks, sedans, SUVs, and luxury cabs ensures clean interiors, air-conditioning, and spacious seating for a smooth ride. With professional chauffeurs, flexible hourly, daily, and outstation taxi packages, transparent pricing, and 24/7 booking support, Sanavi Travels guarantees punctual, dependable, and stress-free travel. We offer convenient doorstep pickup and drop services across Pimpri, Chinchwad, Akurdi, Nigdi, Bhosari, Wakad, Hinjewadi, Pimple Saudagar, and PCMC areas, making us a trusted choice for everyday and long-distance travel. Choose Sanavi Travels for dependable taxi services in Pimpri Chinchwad Pune, delivering comfort, safety, and a seamless travel experience.',

    top: 'Top Places to Visit in Pune with Sanavi Travels',


"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Shaniwar Wada is Pune’s most iconic historical landmark, built in 1732 by the Peshwas of the Maratha Empire. Once the seat of Peshwa administration, it features massive stone walls, grand gates like the Delhi Darwaza, and spacious courtyards. Although partially destroyed by fire, its remains reflect Maratha valor and heritage. The evening light-and-sound show brings Pune’s glorious past to life."
  },
  {
    "title": "Aga Khan Palace",
    "description": "Aga Khan Palace is a significant monument linked to India’s freedom movement. Mahatma Gandhi, Kasturba Gandhi, and Mahadev Desai were imprisoned here during the Quit India Movement. Today, it houses a museum displaying photographs, letters, and personal belongings of Gandhi, set amidst serene gardens."
  },
  {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "The Shreemant Dagdusheth Halwai Ganpati Temple is Pune’s most revered Ganesh temple. The idol is adorned with gold ornaments and attracts thousands of devotees daily. During Ganesh Chaturthi, the temple becomes the epicenter of grand celebrations and cultural events."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Sinhagad Fort is a historic hill fort near Pune, famous for the heroic sacrifice of Tanaji Malusare. Visitors can trek or drive up to the fort to enjoy breathtaking views of the Sahyadri ranges. The fort is popular for trekking, history exploration, and traditional Maharashtrian food."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Pataleshwar Cave Temple is an ancient 8th-century rock-cut shrine dedicated to Lord Shiva. Carved from a single basalt rock, it features monolithic pillars and a peaceful sanctum. Despite being in a busy area, the temple offers a calm spiritual experience."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "Raja Dinkar Kelkar Museum houses over 20,000 artifacts showcasing India’s cultural heritage. The collection includes musical instruments, sculptures, utensils, and ornaments. The recreated Mastani Mahal is a major highlight for visitors."
  },
  {
    "title": "Parvati Hill and Temple",
    "description": "Parvati Hill is one of Pune’s oldest heritage sites, offering panoramic views of the city after climbing 103 stone steps. The Parvati Temple complex, built during the Peshwa era, is dedicated to Lord Shiva and Goddess Parvati and is especially popular during sunrise and sunset."
  },
  {
    "title": "Osho Ashram",
    "description": "Located in Koregaon Park, the Osho International Meditation Resort attracts visitors from across the globe. It offers meditation programs, wellness therapies, and tranquil gardens, making it a center for peace, relaxation, and spiritual growth."
  },
  {
    "title": "Pu La Deshpande Garden",
    "description": "Pu La Deshpande Garden, inspired by Japan’s Korakuen Garden, is Pune’s largest landscaped garden. With bridges, water streams, and manicured lawns, it is ideal for morning walks, family outings, photography, and peaceful relaxation."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam is a popular leisure destination near Pune, especially during the monsoon season. The scenic reservoir, surrounding hills, and cool breeze make it a favorite spot for evening outings and weekend picnics. It also serves as the gateway to Sinhagad Fort."
  }
]
,




"services": [
  {
    "name": "Taxi Service in Pimpri Chinchwad Pune",
    "description": "Taxi Service in Pimpri Chinchwad Pune offers reliable and comfortable local and outstation taxi services with professional drivers."
  },
  {
    "name": "Cab Service PCMC",
    "description": "Cab Service PCMC provides efficient and timely cab solutions for local travel, office commutes, and airport transfers."
  },
  {
    "name": "AC Taxi Pimpri Chinchwad",
    "description": "AC Taxi Pimpri Chinchwad ensures a comfortable and cool ride with air-conditioned vehicles and experienced drivers."
  },
  {
    "name": "Luxury Cab PCMC",
    "description": "Luxury Cab PCMC delivers premium cars for stylish and comfortable travel within Pimpri Chinchwad and nearby areas."
  },
  {
    "name": "Local Taxi Service PCMC",
    "description": "Local Taxi Service PCMC offers convenient taxis for short trips, daily commutes, and intra-city travel with professional drivers."
  },
  {
    "name": "Outstation Taxi PCMC",
    "description": "Outstation Taxi PCMC provides reliable long-distance travel with well-maintained cabs and experienced chauffeurs."
  },
  {
    "name": "Affordable Taxi PCMC",
    "description": "Affordable Taxi PCMC offers budget-friendly taxi services without compromising on comfort or safety."
  },
  {
    "name": "Chauffeur Driven Taxi PCMC",
    "description": "Chauffeur Driven Taxi PCMC ensures a stress-free journey with professional drivers managing navigation and traffic."
  },
  {
    "name": "Best Taxi Service PCMC",
    "description": "Best Taxi Service PCMC provides dependable and high-quality taxi services for local and outstation travel."
  },
  {
    "name": "Pimpri Chinchwad Cab Booking",
    "description": "Pimpri Chinchwad Cab Booking allows easy and quick reservations for taxis with flexible pickup and drop options."
  },
  {
    "name": "Airport Taxi PCMC",
    "description": "Airport Taxi PCMC offers timely and comfortable airport transfers with professional drivers and air-conditioned vehicles."
  },
  {
    "name": "Tourist Taxi PCMC",
    "description": "Tourist Taxi PCMC provides guided travel and convenient transportation to local attractions and sightseeing spots."
  },
  {
    "name": "Corporate Taxi PCMC",
    "description": "Corporate Taxi PCMC offers professional taxi services for business travel, office commutes, and corporate events."
  },
  {
    "name": "Online Cab Booking PCMC",
    "description": "Online Cab Booking PCMC enables quick and easy booking of taxis online with instant confirmation."
  },
  {
    "name": "24x7 Taxi Service PCMC",
    "description": "24x7 Taxi Service PCMC provides round-the-clock taxi availability for emergency travel, night commutes, and outstation trips."
  }
],
"tableData": [
  ["Taxi Service in Pimpri Chinchwad Pune", "Cab Service PCMC"],
  ["AC Taxi Pimpri Chinchwad", "Luxury Cab PCMC"],
  ["Local Taxi Service PCMC", "Outstation Taxi PCMC"],
  ["Affordable Taxi PCMC", "Chauffeur Driven Taxi PCMC"],
  ["Best Taxi Service PCMC", "Pimpri Chinchwad Cab Booking"],
  ["Airport Taxi PCMC", "Tourist Taxi PCMC"],
  ["Corporate Taxi PCMC", "Online Cab Booking PCMC"],
  ["24x7 Taxi Service PCMC", "—"]
]
,


"whychoose": [
  {
    "WhyChooseheading": "Taxi Service in Pimpri Chinchwad Pune with Sanavi Travels",
    "WhyChoosedescription": "Sanavi Travels offers reliable and affordable taxi services in Pimpri Chinchwad Pune for local travel, airport transfers, business trips, and daily commuting."
  },
  {
    "WhyChooseheading": "Comfortable and Clean Taxis",
    "WhyChoosedescription": "Travel in well-maintained, air-conditioned taxis that ensure a smooth, comfortable, and hygienic ride across Pimpri Chinchwad Pune."
  },
  {
    "WhyChooseheading": "Experienced and Professional Drivers",
    "WhyChoosedescription": "Our drivers are licensed, courteous, and well-acquainted with the local area to ensure timely and safe journeys."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Sanavi Travels provides upfront pricing for all taxi services in Pimpri Chinchwad Pune with no hidden fees."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our customer support team is available round-the-clock to assist with bookings, travel updates, and route planning."
  },
  {
    "WhyChooseheading": "Flexible Booking Options",
    "WhyChoosedescription": "Choose from immediate bookings, advance reservations, hourly rentals, or full-day taxi services as per your needs."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "All taxis are thoroughly cleaned and sanitized before every ride to ensure passenger safety and comfort."
  },
  {
    "WhyChooseheading": "Reliable and On-Time Service",
    "WhyChoosedescription": "We guarantee punctual pickups and dependable services, making Sanavi Travels a trusted taxi service in Pimpri Chinchwad Pune."
  }
]

}

const faqData = [
  {
    question: 'Does Sanavi Travels provide taxi services in Pimpri Chinchwad Pune?',
    answer: 'Yes, Sanavi Travels offers reliable taxi services in Pimpri Chinchwad Pune for all types of local travel needs.'
  },
  {
    question: 'How can I book a taxi in Pimpri Chinchwad Pune?',
    answer: 'You can book easily through our website or by contacting our 24x7 customer support team.'
  },
  {
    question: 'What types of taxis are available in Pimpri Chinchwad Pune?',
    answer: 'Sanavi Travels provides hatchbacks, sedans, SUVs, and premium cars for taxi services in Pimpri Chinchwad Pune.'
  },
  {
    question: 'Are the drivers experienced with Pimpri Chinchwad routes?',
    answer: 'Yes, our drivers are professional, licensed, and well-familiar with the Pimpri Chinchwad Pune area.'
  },
  {
    question: 'Can I book a taxi for an hourly basis?',
    answer: 'Yes, you can book taxis on an hourly basis according to your travel requirements.'
  },
  {
    question: 'Is taxi service available 24x7 in Pimpri Chinchwad Pune?',
    answer: 'Yes, Sanavi Travels offers round-the-clock taxi services in Pimpri Chinchwad Pune.'
  },
  {
    question: 'Are the taxis sanitized before every ride?',
    answer: 'Yes, all taxis are thoroughly cleaned and sanitized before each trip.'
  },
  {
    question: 'What payment options are available?',
    answer: 'We accept UPI, credit/debit cards, digital wallets, and cash payments.'
  },
  {
    question: 'Is customer support available during the taxi ride?',
    answer: 'Yes, our 24x7 customer support team is available throughout your taxi journey.'
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Suresh Kulkarni',
    feedback: 'Booked a taxi in Pimpri Chinchwad Pune from Sanavi Travels. Comfortable ride and friendly driver.',
    rating: 5
  },
  {
    id: 2,
    name: 'Ms. Priyanka Sharma',
    feedback: 'Great and reliable taxi service in Pimpri Chinchwad Pune with prompt pickups and excellent support.',
    rating: 5
  }
];




























































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];











const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Taxi Service in Pimpri Chinchwad Pune - Sanavi Travels",
  "description": "Book taxi services in Pimpri Chinchwad, Pune with Sanavi Travels. AC and luxury taxis for local travel, outstation trips, airport transfers, corporate travel, tourist journeys, and chauffeur-driven service, available 24x7.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "1600"
  }
};



  return (
    <div>


<Helmet>
  <title>
    Taxi Service in Pimpri Chinchwad Pune | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Hire AC and luxury taxis in Pimpri Chinchwad, Pune with Sanavi Travels. Perfect for local travel, outstation trips, airport transfers, corporate travel, tourist journeys, and safe chauffeur-driven service, available 24x7."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>

      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/72.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Taxiserviceinpimprichichwadpune;